export default "__VITE_ASSET__CI$aMBJD__"